/*
  DIIP UPDATE: รองรับลิงก์จาก Header (Navigation Menu) ให้เปิด Tab ที่ต้องการ
  ได้โดยตรง เช่น ลิงก์ไปที่ /pages/shop#shop-tab-2 จะเปิด Tab 2 (Gummies) เลย
  ไม่ต้องเข้ามาแล้วกด Tab เองอีกที — วิธีตั้งค่าใน Shopify Admin:
  Online Store > Navigation > แก้/เพิ่มเมนู > Link URL ใส่เป็น
  [URL หน้า Shop]#shop-tab-2 (เลข 2 ตรงกับลำดับ Tab จริง)

  DIIP FIX: ใช้ #shop-tab-2 (มี "shop-" นำหน้า) แทน #tab-2 ตรงๆ เพราะ #tab-2
  ไปตรงกับ id="tab-2" ของ Content Div จริงในหน้าเว็บ ทำให้ Browser auto-scroll
  ไปที่ตรงนั้นเองทันทีตามพฤติกรรมปกติของ Browser (ก่อนที่สคริปต์เราจะทำงาน
  ด้วยซ้ำ) กลายเป็นหน้าเปิดมาแล้วอยู่กลางหน้าจอไม่ใช่บนสุด — เปลี่ยนชื่อ Hash
  ให้ไม่ตรงกับ id ไหนเลยในหน้าเว็บ Browser จะไม่ auto-scroll ไปไหนเองอีกแล้ว
  ปล่อยให้สคริปต์เป็นคนจัดการ Tab อย่างเดียว หน้าเว็บจะเปิดมาบนสุดตามปกติ
*/
function diipActivateShopTab(section, targetId) {
  var targetPill = section.querySelector('[data-tab-target="' + targetId + '"]');
  var targetContent = section.querySelector('#' + targetId);
  if (!targetPill || !targetContent) return false;

  section.querySelectorAll('.diip-shop__pill').forEach(function (p) {
    p.classList.remove('is-active');
  });
  section.querySelectorAll('.diip-shop__tab-content').forEach(function (content) {
    content.classList.remove('is-active');
  });

  targetPill.classList.add('is-active');
  targetContent.classList.add('is-active');
  return true;
}

function diipHandleShopHashChange() {
  var hash = window.location.hash; // เช่น "#shop-tab-2"
  if (!hash || hash.indexOf('#shop-tab-') !== 0) return;
  var targetId = 'tab-' + hash.replace('#shop-tab-', ''); // "#shop-tab-2" -> "tab-2"
  document.querySelectorAll('.diip-shop').forEach(function (section) {
    diipActivateShopTab(section, targetId);
  });
}

diipHandleShopHashChange(); // เช็คตอนโหลดหน้าเว็บครั้งแรก

/*
  DIIP FIX: ถ้าเปิดหน้า Shop อยู่แล้ว แล้วกดลิงก์เมนูอื่นที่ต่างกันแค่ Hash
  (เช่นจาก #shop-tab-2 ไป #shop-tab-3) Browser จะไม่ Reload หน้าใหม่ให้เลย
  (ถือเป็นแค่การเปลี่ยน Hash ในหน้าเดิม) โค้ดที่รันแค่ตอนโหลดหน้าครั้งแรก
  (ด้านบน) จึงไม่ถูกเรียกซ้ำ ทำให้ Tab ค้างอยู่ที่ตัวแรกที่กดไปตลอด ต้องดักฟัง
  Event "hashchange" เพิ่ม เพื่อสลับ Tab ทุกครั้งที่ Hash เปลี่ยน ไม่ว่าจะมี
  การ Reload หน้าจริงหรือไม่ก็ตาม
*/
window.addEventListener('hashchange', diipHandleShopHashChange);

document.querySelectorAll('.diip-shop__pill').forEach(function (pill) {
  pill.addEventListener('click', function () {
    var targetId = pill.getAttribute('data-tab-target');
    var section = pill.closest('.diip-shop');
    if (!section) return;
    diipActivateShopTab(section, targetId);
  });
});

/* ---------- Add to Cart จริง ผ่าน Shopify Cart AJAX API + เปิด Cart Drawer ของธีมจริง ---------- */
document.querySelectorAll('[data-add-to-cart]').forEach(function (button) {
  var originalText = button.textContent;
  var card = button.closest('.diip-shop-card');
  var messageEl = card ? card.querySelector('[data-cart-message]') : null;

  button.addEventListener('click', function () {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.disabled = true;
    button.textContent = 'กำลังเพิ่ม...';
    if (messageEl) {
      messageEl.textContent = '';
      messageEl.className = 'diip-shop-card__cart-message';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function (data) {
        if (messageEl) {
          messageEl.textContent = 'เพิ่มลงตะกร้าแล้ว ✓';
          messageEl.className = 'diip-shop-card__cart-message is-success';
        }

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          // วิธีมาตรฐานของ Dawn: อัปเดตเนื้อหาข้างในตะกร้า + เปิด Drawer ออกมาให้เอง
          cartDrawer.renderContents(data);
        } else if (data.sections) {
          // Fallback เผื่อธีมไม่ได้ใช้ <cart-drawer> element: แทนที่ HTML ของแต่ละ section ตรงๆ
          Object.keys(data.sections).forEach(function (sectionId) {
            var target = document.getElementById(sectionId);
            if (!target) return;
            var temp = document.createElement('div');
            temp.innerHTML = data.sections[sectionId];
            var replacement = temp.firstElementChild;
            if (replacement) target.replaceWith(replacement);
          });
          var cartIcon = document.getElementById('cart-icon-bubble');
          if (cartIcon) cartIcon.click();
        }
      })
      .catch(function () {
        if (messageEl) {
          messageEl.textContent = 'เพิ่มไม่สำเร็จ กรุณาลองใหม่';
          messageEl.className = 'diip-shop-card__cart-message is-error';
        }
      })
      .finally(function () {
        button.disabled = false;
        button.textContent = originalText;
      });
  });
});
